import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dxbpbs3sh: FaireProductEntity = {
  token: "p_9dxbpbs3sh",
  type: "product",
  name: "Melt N Grow Yeti, Holiday, Christmas, stocking stuffer",
  brandToken: "b_83nqde8ah7",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/00bc846e6e0143320e6bb75744436eb47805cd715d4792bb3eae9f3e18871f9e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34d725f78c56f464f6dfc5aff13c1ac05ad654a64da9746e9d3456a9e1aef484.jpeg",
    "https://cdn.faire.com/fastly/33ce2828f5f91285aad9328e50af508233688d9f1ff60841b30ac7a5f1682b61.jpeg",
    "https://cdn.faire.com/fastly/6b6bd28a86679f383b90b4cb7454abd0b19035d668fbd95655f1ec618d1b8716.jpeg",
    "https://cdn.faire.com/fastly/b635b37dfa818564314be294bbfba43342c93deca134478fc56473ff18c29fe6.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Melt N Grow Yeti emerges from blue and white iceberg when submerged in water and can expand up to 4 inches in height. An especially good seller during the winter holidays and is great for kids who love arts and crafts, surprises, and playing with water. Each DIY Grow Yeti comes in its own box illustrated with cartoon yeti creatures, snow mountains, and growing trees. 12 DIY Grow Yeti kits per pack.\r\n\r\n• Age Grade: 5+\r\n• Product Dimensions/Weight: 3.3 L x 2.6 W x 4.0 H / 1.0 lb\r\n• Inner Pack Dimensions/Weight: 8.7 L x 7.1 W x 8.5 H / 3.1 lb\r\n• Made In: China\r\n• Batteries not required",
  tags: [],
  msrpDollars: 8.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:23.749Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
